import { TRIGGER_FETCH_PINCODE_DETAILS_API, TRIGGER_FETCH_PINCODE_DETAILS_API_SUCCESS } from 'redux/actionTypes';

export function triggerFetchPincodeDetailsApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_FETCH_PINCODE_DETAILS_API,
		data,
		stopLoader,
		callback,
	};
}

export function triggerFetchPincodeDetailsApiCallSuccess(data) {
	return {
		type: TRIGGER_FETCH_PINCODE_DETAILS_API_SUCCESS,
		data,
	};
}
